import React from 'react';
import { LOCATION_PAGE } from '../../lib/queries';
import client from '../../lib/apolloClient';
import Layout from '../../src/components/Layout/Layout';
import LocationComponent from '../../src/components/Locations/Location';
import replacePictureUrlWithSignedUrl from '../../src/utils/replaceUrlWithSigned/replaceUrlWithSigned';

const Location = (props) => {
  const { data } = props;

  return (
    <Layout>
      <LocationComponent data={data.locations[0]} />
    </Layout>
  );
};

export default Location;

export async function getServerSideProps(context) {
  const { pid } = context.query;
  let { data } = await client.query({
    query: LOCATION_PAGE,
    variables:
    { where: { airportCode: pid } },
  });
  data = await replacePictureUrlWithSignedUrl(data);
  if (data && data.locations.length > 0) {
    return {
      props: { data },
    };
  }
  return {
    notFound: true,
  };
}
